import { Popover } from '@headlessui/react';
import { ArrowRightIcon, XMarkIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { NavigationMenuItem } from '@models/navigation';
import { ContentType } from '@models/pages';
import SubMobileMegaMenu from './SubMobileMegaMenu';
import LinkChd from '../../LinkChd';
import SocialMediaIcons from '../navbar/SocialMediaIcons';

type Props = {
  megaMenu: any,
  navbarButtons: any,
  chdSearch: any,
  socialMediaIcons: NavigationMenuItem,
}

export default function MobileMegaMenu({
  megaMenu, navbarButtons, chdSearch, socialMediaIcons,
}: Props) {
  return (
    <div className="relative flex flex-col">
      <LinkChd
        link={chdSearch}
        linkStyles="w-fit"
        wrap
      >
        <div className="flex text-chdBlue text-[18px] font-semibold items-center">
          <span className="mr-2">Search</span>
          <svg width="14" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.3006 5.44444C10.3006 7.86439 8.25392 9.88889 5.65032 9.88889C3.04671 9.88889 1 7.86439 1 5.44444C1 3.0245 3.04671 1 5.65032 1C8.25392 1 10.3006 3.0245 10.3006 5.44444Z" stroke="#0080A3" strokeWidth="2" />
            <line y1="-1" x2="8.44638" y2="-1" transform="matrix(0.764529 0.644589 -0.672266 0.74031 8.07129 8.55469)" stroke="#0080A3" strokeWidth="2" />
          </svg>
        </div>
      </LinkChd>
      <Popover.Button type="button" className="w-full block z-[70]">
        <XMarkIcon width={40} className="absolute -top-1.5 right-10" color="dimGray" />
      </Popover.Button>
      <div className="flex flex-col my-[28px]">
        {megaMenu.map(
          (menuItem: NavigationMenuItem) => {
            if (menuItem
              && menuItem.internal?.type
              === ContentType.ContentfulMegaMenu) {
              return (
                <Popover key={menuItem.id}>
                  <SubMobileMegaMenu
                    title={menuItem.title}
                    menuItem={menuItem}
                  />
                </Popover>
              );
            }
            return (
              <LinkChd
                key={menuItem.id}
                link={menuItem}
                linkStyles="text-black hover:text-darkCyan text-[24px] leading-[44px] font-semibold w-fit"
                wrap
              >
                {menuItem.title}
              </LinkChd>
            );
          },
        )}
      </div>
      {navbarButtons.map(
        (navButton: any) => (
          <LinkChd wrap key={navButton.id} link={navButton} linkStyles="flex group">
            <button type="button" className="align-middle text-center font-['Open_Sans'] whitespace-nowrap text-darkCyan hover:text-blueLagoon text-[16px] lg:block font-semibold leading-[28px]">
              {navButton.title}
            </button>
            <ArrowRightIcon className="ml-2 duration-300 transform group-hover:ml-4 text-darkCyan hover:text-blueLagoon" width={15} />
          </LinkChd>
        ),
      )}
      <div className="flex items-start w-full my-3">
        <SocialMediaIcons
          socialMediaIcons={socialMediaIcons}
          width={26}
        />
      </div>
    </div>
  );
}
